import { useState, useEffect } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { arrowRight } from 'assets/icons/importIcon';
import LabelInput from 'components/Base/LabelInput';
import LabelTextArea from 'components/Base/LabelTextArea';
import UploadMedia from 'components/Base/UploadMedia';
import { iconInfor2 } from 'assets/icons';
import { useDispatch, useSelector } from 'react-redux';

import { TYPE_NAME_BRIK, TYPE_BRIK, TYPE_LENGTH, TYPE_PAYMENT_BRIK } from 'utils';
import {
  Checkbox,
  FormControlLabel,
  Tooltip,
  Button,
  CircularProgress,
} from '@material-ui/core';
import {
  createBrik,
  updateBrik,
  createLength,
  createSection,
  duplicateBrik,
} from 'actions/brik';
import { debounce } from 'lodash';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import AppHelper from 'helpers/AppHelper';
import useStyles from './styles';
import { StripeConnectButton } from 'components/Base/StripeConnectButton';

const CreateDetailBrik = (props: any) => {
  const classes = useStyles();
  const {
    typeBrik,
    typeName = '',
    typePayment,
    setTypePayment,
    isEdit,
    itemEdit,
    nextStep,
    backStep,
    isFromDetail,
    handleCloseModal,
    item,
    isDuplicate,
    refresh,
    typeLength,
    handleTypeBrik,
    setTypeBrik
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { loading } = useSelector((state: any) => state.brik);
  const { info } = useSelector((state: any) => state.appInfo);
  const [brikImage, setBrikImage] = useState<any>();
  const [data, setData] = useState<any>();
  const [checked, setChecked] = useState<boolean>(true);
  const [isGroupPriceFree, setIsGroupPriceFree] = useState<boolean>(true);
  const [isOneOnOneFree, setIsOneOnOneFree] = useState<boolean>(true);
  const {
    setValue,
    getValues,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onSubmit' });

  const priceValidate = {
    required: checked ? false : true,
    validate: (value: any) => {
      if (!checked) {
        if (value < 0) {
          return 'Invalid value. Value must be greater than 0';
        } else if (!new RegExp(/^[+-]?\d+(\.\d+)?$/).test(value)) {
          return 'Invalid value.';
        }
      } else return;
    },
  };

  const priceOneOnOneValidate = {
    required: isOneOnOneFree ? false : true,
    validate: (value: any) => {
      if (!checked) {
        if (value < 0) {
          return 'Invalid value. Value must be greater than 0';
        } else if (!new RegExp(/^[+-]?\d+(\.\d+)?$/).test(value)) {
          return 'Invalid value.';
        }
      } else return;
    },
  };

  const pricGroupeValidate = {
    required: isGroupPriceFree ? false : true,
    validate: (value: any) => {
      if (!checked) {
        if (value < 0) {
          return 'Invalid value. Value must be greater than 0';
        } else if (!new RegExp(/^[+-]?\d+(\.\d+)?$/).test(value)) {
          return 'Invalid value.';
        }
      } else return;
    },
  };

  useEffect(() => {
    if (isDuplicate) {
      const priceGroup = item?.price_group ? item?.price_group : 0;
      const price = item?.price ? item?.price : 0;

      setValue('brikName', item?.name);
      setValue('brikDesc', item?.description);
      setValue('payment', item?.type_payment);
      setValue('typeLength', item?.length);

      setTypePayment(item?.type_payment);

      if (typeBrik === TYPE_BRIK.GROUPS) {
        if (priceGroup === 0) {
          setIsGroupPriceFree(true);
        } else {
          setIsGroupPriceFree(false);
        }
  
        if (price === 0) {
          setIsOneOnOneFree(true)
        } else {
          setIsOneOnOneFree(false)
        }

        setValue('price', price);
        setValue('priceGroup', priceGroup);

      } else  {
        if (item?.type_payment === TYPE_PAYMENT_BRIK.ONE_TIME) {
          setChecked(false);
          setValue('priceSub', price);
        } else {
          setChecked(true);
          setValue('priceSub', 0);
        }
      }
      setData(item)
    } else if (itemEdit) {
      const priceGroup = itemEdit?.price_group ? itemEdit?.price_group : 0;
      const price = itemEdit?.price ? itemEdit?.price : 0;

      setValue('brikName', itemEdit?.name);
      setValue('brikDesc', itemEdit?.description);

      setValue('typeLength', itemEdit?.length);
      setValue('payment', itemEdit?.type_payment);

      setTypePayment(itemEdit?.type_payment);

      if (typeBrik === TYPE_BRIK.GROUPS) {
        if (priceGroup === 0) {
          setIsGroupPriceFree(true);
        } else {
          setIsGroupPriceFree(false);
        }
  
        if (price === 0) {
          setIsOneOnOneFree(true)
        } else {
          setIsOneOnOneFree(false)
        }
        setValue('price', price);
        setValue('priceGroup', priceGroup);
      } else {
        if (itemEdit?.type_payment === TYPE_PAYMENT_BRIK.ONE_TIME) {
          setChecked(false);
          setValue('priceSub', price);
        } else {
          setChecked(true);
          setValue('priceSub', 0);
        }
      }
      setData(itemEdit)
    } else {
      setValue('price', 0);
      setValue('priceGroup', 0);
      setValue('priceSub', 0);
    }
  }, [info]);

  const handleCreateFormBrik = async () => {

    const price = getValues('priceSub') !== null && getValues('priceSub') !== undefined ? 
      parseFloat(getValues('priceSub')) > 0 ? parseFloat(getValues('priceSub')?.replace(/^0+/, '')) : 0 : 
      parseFloat(getValues('price')) > 0 ? parseFloat( getValues('price')?.replace(/^0+/, ''))  : 0;
    const priceGroup = typeBrik === TYPE_BRIK.GROUPS ? ( 
      getValues('priceGroup') !== null && getValues('priceGroup') !== undefined ?  parseFloat(getValues('priceGroup')) > 0  ? parseFloat(getValues('priceGroup')?.replace(/^0+/, '')) : 0
      : 0) : null;

    if (isDuplicate) {
      const params: any = {
        id: item?.id,
        type_name: typeName,
        type_brik: typeBrik,
        name: getValues('brikName'),
        description: getValues('brikDesc'),
        length: typeLength,
        type_payment: typePayment,
        price:  price,
        price_group: priceGroup,
      };
      if (brikImage) {
        params.newImage = brikImage;
      } else {
        params.image = data?.image.replace(`${process.env.REACT_APP_STORAGE_DOMAIN}/`, '');
      }
      await dispatch(duplicateBrik(item?.id, params));

      if (refresh) {
        await refresh();
      }

      handleCloseModal();
    } else if (isEdit) {
      const params = {
        type_name: typeName,
        type_brik: typeBrik,
        name: getValues('brikName'),
        description: getValues('brikDesc'),
        length: typeLength,
        image: brikImage,
        type_payment: typePayment,
        price:  price,
        price_group: priceGroup
      };
      dispatch(
        await updateBrik(
          itemEdit?.id,
          params,
          isFromDetail,
          itemEdit?.type_name
        )
      );

      if (refresh) {
        await refresh();
      }
    } else {


      const params = {
        type_name: typeName,
        type_brik: typeBrik,
        name: getValues('brikName'),
        description: getValues('brikDesc'),
        length: typeLength,
        image: brikImage,
        type_payment: typePayment,
        price: price,
        price_group: priceGroup
      };

      if (typeBrik === TYPE_BRIK.SUBSCRIBERS && params?.price === 0) {
        params.type_brik = TYPE_BRIK.EVERYONE;
      }

      const newBrik: any = await dispatch(createBrik(params));
      if (newBrik) {
        if (typeLength === TYPE_LENGTH.NO_DURATION) {
          if (typeName === TYPE_NAME_BRIK.LESSON) {
            await dispatch(
              createSection(newBrik.id, { type_section: 0, order: 1 })
            );
          }

          AppHelper.hideGlobalModal();
          history.push(`/brik/detail/${newBrik.id}`, {
            length: typeLength,
          });
        } else if (typeLength === TYPE_LENGTH.DAY) {
          const newDay: any = await dispatch(
            createLength(newBrik.id, {
              type: 1,
              order: 1
            })
          );
          if (typeName === TYPE_NAME_BRIK.LESSON) {
            if (newDay.payload.id) {
              await dispatch(
                createSection(newBrik.id, {
                  type_section: 0,
                  order: 1,
                  length_id: newDay.payload.id,
                })
              );
            }

            AppHelper.hideGlobalModal();
            history.push(`/brik/detail/${newBrik.id}`, {
              length: typeLength,
            });
          }
        } else if (typeLength === TYPE_LENGTH.WEEK) {
          await dispatch(
            createLength(newBrik.id, {
              type: 2,
              order: 1
            })
          );
          AppHelper.hideGlobalModal();
          history.push(`/brik/detail/${newBrik.id}`, {
            length: typeLength,
          });
        }
        nextStep();
      }
    }

    AppHelper.hideGlobalModal();
  };

  const onHandleCloseModal = () => {
    if (handleCloseModal) {
      handleCloseModal();
    } else {
      AppHelper.hideGlobalModal();
    }
  };

  const onChangeImageBrik = (image: any, thumbnailImage: any) => {
    setBrikImage(image);
  };

  const onChangeBlurPriceSub = (e: any) => {
    setValue('priceSub', getValues('priceSub')?.replace(/^0+/, ''));
  };

  const onPriceSubChange = (e: any) => {
    setValue('priceSub', getValues('priceSub')?.replace(/^0+/, ''));
  }

  const onPriceOnChange = (e: any) => {
    if (parseFloat(e.target.value) > 0) {
      setIsOneOnOneFree(false)
      setValue('price', parseFloat(e.target.value?.replace(/^0+/, '')));
    } else {
      setIsOneOnOneFree(true);
      setValue('price', 0);
    }
  }

  const handleChangeChecked = () => {
    const isChecked = !checked;
    setChecked(isChecked);
    if (isChecked) {
      const price = item?.price ? item?.price : 0;
      setValue('priceSub', price);
      if (handleTypeBrik) {
        handleTypeBrik(TYPE_BRIK.SUBSCRIBERS);
      } else if (setTypeBrik) {
        setTypeBrik(TYPE_BRIK.SUBSCRIBERS);
      }
      setTypePayment(TYPE_PAYMENT_BRIK.SUBCRIPTION);
    } else {
      if (handleTypeBrik) {
        handleTypeBrik(TYPE_BRIK.EVERYONE);
      } else if (setTypeBrik) {
        setTypeBrik(TYPE_BRIK.EVERYONE);
      }
      setTypePayment(TYPE_PAYMENT_BRIK.ONE_TIME);
      if (isDuplicate) {
        const price = item?.price ? item?.price : 0;
        setValue('priceSub', price);
      } else {
        const price = itemEdit?.price ? itemEdit?.price : 0;
        setValue('priceSub', price);
      }
    }
  };

  const handleSetTypePayment = (e: any) => {
    setTypePayment(e);
  };

  const renderTypeNameBrik = () => {
    if (item) {
      switch (item?.type_name) {
        case 0:
          return 'lesson plan';
        case 1:
          return 'program';
        case 2:
          return 'challenge';
        case 5:
          return 'life and leadership coaching';
      }
    }
    switch (!itemEdit ? typeName : itemEdit?.type_name) {
      case 0:
        return 'lesson plan';
      case 1:
        return 'program';
      case 2:
        return 'challenge';
      case 5:
        return 'life and leadership coaching';
    }
  };

  const onKeyPressEvent = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const testStrValue = `${event?.target?.value}${keyValue}`;
    const countDot = testStrValue.length - testStrValue?.replaceAll('.', '')?.length || 0;
    let maxLetNumber = 1000000;
    if (!(new RegExp("[0-9.]").test(keyValue))) {
      event.preventDefault();
    } else {
      if (countDot > 1) {
        event.preventDefault();
      } else {
        if (parseFloat(testStrValue) >= maxLetNumber) {
          event.preventDefault();
        }
      }
    }
    return;
  };

  const setFreeOneOnOne = () => {
    if (isOneOnOneFree) {
      setValue('price', 0);
      setIsOneOnOneFree(false)
    } else {
      setValue('price', 0);
      setIsOneOnOneFree(true)
    }
  }

  const isEnabledFields = () => {
    if (isDuplicate) {
      return false;
    } else {
      if (info?.stripe_submitted === 0) {
        return true;
      } else if (!isDuplicate && !isEdit) {
        return false;
      } else if (isEdit && itemEdit && (itemEdit?.status === "Not Shared" || itemEdit?.status === "In Draft")) {
        return false;
      }
      return true;
    }

  };

  return (
    <>
      <div className={classes.bodyModalList}>
        <div className={classes.iconCloseIcon} onClick={onHandleCloseModal}>
          <CloseIcon />
        </div>
        <div className={classes.contentTitle} data-cy="cypress-course-plan-modal-header">
          Fill in {renderTypeNameBrik()} details
        </div>
        <div className={classes.contentContainer}>
          <div style={{ width: "90%" }}>
            <LabelInput
              name='brikName'
              label={`${renderTypeNameBrik()} Name`}
              customClass={classes.inputName}
              required={true}
              ref={register({ required: true })}
              maxLength={50}
              errors={errors?.brikName}
              cypressId='cypress-course-plan-name-input'
            />
            <LabelTextArea
              name='brikDesc'
              label={`${renderTypeNameBrik()} description`}
              customClass={classes.customTextArea}
              ref={register({ required: true })}
              required={true}
              maxLength={255}
              errors={errors?.brikDesc}
              cypressId='cypress-course-plan-desc-input'
            />
          </div>
          <div>
         
            {
              typeBrik !== TYPE_BRIK.GROUPS ?
                <UploadMedia
                  label='Image'
                  placeholder={'Click to upload an image'}
                  customClass={classes.customUploadImage}
                  onChangeImage={onChangeImageBrik}
                  name='brikImage'
                  ref={register({ required: true })}
                  errors={errors?.brikImage}
                  mediaUrl={isDuplicate ? item?.image : itemEdit?.image}
                /> : null
            }

            {
              info?.stripe_submitted ?
              <div>
                {(typeBrik === TYPE_BRIK.SUBSCRIBERS ||
                  typeBrik === TYPE_BRIK.EVERYONE) && (
                    <div className={`${classes.containerInputPrice} ${checked ? '' : errors?.priceSub ? classes.containerErr : ''}`}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <label className={classes.textLabelInputPrice}>Price</label>
                          <Tooltip
                              placement='top'
                              title={
                                itemEdit?.status !== "live" ?
                                <span style={{ whiteSpace: 'pre-line' }}>
                                  Customers and members must pay this amount to access this Brik module.
                                </span> : <span style={{ whiteSpace: 'pre-line' }}>
                                  You can't modify live Brik prices; consider duplicating with updated costs, then hide the original. Users who have started or paid for this Brik will retain access.
                                </span>
                              }
                              classes={{
                                tooltip: classes.tooltip,
                                arrow: classes.popupTooltip,
                              }}
                            >
                            <img src={iconInfor2} style={{ width: "15px", height: "15px", marginLeft: "-5px" }} />
                          </Tooltip>
                   
                      </div>
                      <div className={classes.rowCheckBox}>
                        <Checkbox
                          data-cy="cypress-course-plan-checkbox" 
                          checked={info?.stripe_submitted && checked}
                          onChange={handleChangeChecked}
                          style={{
                            color: isEnabledFields() ? '#D2D2D2' : '#333',
                          }}
                          disabled={isEnabledFields()}
                          
                        />
                        <span
                          className={classes.textLabelDescPrice}
                          style={{ color: isEnabledFields() ? '#D2D2D2' : '' }}
                        >
                          This is included with the subscription
                        </span>
                      </div>
                      <div
                        className={`
                          ${classes.contentInputPrice} 
                          ${errors?.priceSub && classes.errInputPrice} 
                          ${(isEnabledFields()) && `${classes.disableInputPrice} `}`}
                      >
                        <span className={classes.priceSymbol}>$</span>
                        <input
                          disabled={isEnabledFields() || checked}
                          className={classes.inputPrice}
                          onBlur={debounce(onChangeBlurPriceSub, 300, {
                            leading: true,
                            trailing: false,
                          })}
                          onChange={onPriceSubChange}
                          name='priceSub'
                          ref={register(priceValidate)}
                          type='text'
                          maxLength={9}
                          onKeyPress={onKeyPressEvent}
                          data-cy="cypress-course-plan-price"
                        />
                      </div>
                    </div>
                )}
                {typeBrik === TYPE_BRIK.GROUPS && (
                  <>
                    <div style={{ marginBottom: 10 }}>
                      <div className={classes.labelPayment}>
                        <label className={classes.textLabelInputPrice}>
                          Payment
                        </label>
                        <Tooltip
                          placement='top'
                          title={
                            <span style={{ whiteSpace: 'pre-line' }}>
                              {`By unchecking this box, you can set a stand alone price on top of a\n subscription. BRIKs with a stand alone price will always be\n available to customers who purchase this BRIK, but you can still\n hide and delete stand alone priced BRIKs from future customers.`}
                            </span>
                          }
                          classes={{
                            tooltip: classes.tooltip,
                            arrow: classes.popupTooltip,
                          }}
                        >
                          <img src={iconInfor2} style={{ width: "15px", height: "15px" }} />
                        </Tooltip>
                      </div>
                      <FormControlLabel
                        value='1'
                        className={classes.paymentCheckbox}
                        control={
                          <Checkbox
                            data-cy="cypress-course-1-time-payment-checkbox" 
                            style={{
                              color: isEnabledFields() ? "#D2D2D2" : "#000", 
                            }}
                            checked={typePayment === TYPE_PAYMENT_BRIK.ONE_TIME}
                            onChange={() => handleSetTypePayment(TYPE_PAYMENT_BRIK.ONE_TIME)}
                          />
                        }
                        label='1 time payment'
                        disabled={isEnabledFields()}
                      />
                      <FormControlLabel
                        value='2'
                        className={classes.paymentCheckbox}
                        control={
                          <Checkbox
                            data-cy="cypress-course-recurring-monthly-payment-checkbox" 
                            style={{
                              color: isEnabledFields() ? "#D2D2D2" : "#000", 
                            }}
                            checked={typePayment === TYPE_PAYMENT_BRIK.MONTHLY}
                            onChange={() => handleSetTypePayment(TYPE_PAYMENT_BRIK.MONTHLY)}
                          />
                        }
                        label='Recurring monthly payment'
                        disabled={isEnabledFields()}
                      />
                    </div>

                    <div className={`${classes.pricingLblContainer} ${classes.pricingLblContainerMarginTop}`}>
                      <div className={classes.pricingLbl}>1:1 Price</div>
                      <Tooltip
                        placement='top'
                        title={
                          <span style={{ whiteSpace: 'pre-line' }}>
                            {`You can set a price for individuals\n that get invited to this BRIK`}
                          </span>
                        }
                        classes={{
                          tooltip: classes.tooltip,
                          arrow: classes.popupTooltip,
                        }}
                      >
                        <img src={iconInfor2} style={{ width: "15px", height: "15px" }} />
                      </Tooltip>
                    </div>

                    <FormControlLabel
                      value='1'
                      className={classes.setFreeCheckBox}
                      control={
                        <Checkbox
                        data-cy="cypress-course-set-as-free-checkbox" 
                          checked={isOneOnOneFree}
                          style={{
                            color: "#000",
                          }}
                          onChange={() => setFreeOneOnOne()}
                        />
                      }
                      label='Set as free'
                      disabled={false}
                    />
              
                    <LabelInput
                      label=''
                      name='price'
                      onChange={onPriceOnChange}
                      customClass={classes.customInputPrice}
                      isPrice={true}
                      errors={errors?.price}
                      ref={register(priceOneOnOneValidate)}
                      maxLength={9}
                      disable={isEnabledFields() || isOneOnOneFree}
                      cypressId='cypress-course-price-label-input'
                    />
                  </>
                )}
              </div> : null
            }

            {
              !info?.stripe_submitted && 
                <StripeConnectButton />
            }

           
          </div>
          <div>
            
          </div>
          {
            typeBrik === TYPE_BRIK.GROUPS ?
              <UploadMedia
                label='Image'
                placeholder={'Click to upload an image'}
                customClass={classes.customUploadImage}
                onChangeImage={onChangeImageBrik}
                name='brikImage'
                ref={register({ required: true })}
                errors={errors?.brikImage}
                mediaUrl={isDuplicate ? item?.image : itemEdit?.image}
              /> : null
          }

        </div>
      </div>
      <div className={classes.footerModal}>
        <div className={classes.buttonBack}>
          <Button variant='contained' onClick={(e: any) => backStep(e, typeName)} disabled={isEdit} data-cy="cypress-course-plan-detail-back-button">
            Back
          </Button>
        </div>
        <div className={classes.btnAddRecipeBody}>
          <Button
            variant='contained'
            onClick={handleSubmit(handleCreateFormBrik)}
            disabled={loading}
          >
            {!isEdit
              ?
              <>
                <span data-cy="cypress-course-plan-next-button">Next</span>
                {loading ? (
                  <span className={classes.iconLoading}>
                    <CircularProgress size={16} />
                  </span>
                ) : (
                  <img src={arrowRight} alt='' />
                )}
              </>
              :
              <div style={{ width: 70 }}>
                <span data-cy="cypress-course-plan-save-button">Save</span>
                {loading && (
                  <span className={classes.iconLoading}>
                    <CircularProgress size={16} />
                  </span>
                )}
              </div>
            }
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreateDetailBrik;
